/**
 * formatDateWithPattern
 * @param {Date} date to be formatted
 * @param {string} pattern to be used for formatting, e.g. 'dd.MM.yyyy'
 * @returns {string} formatted date string
 */
function formatDateWithPattern(date, pattern) {
    if (!date || !pattern) {
        return '';
    }
    const map = {
        dd: String(date.getDate()).padStart(2, '0'),
        d: date.getDate(),
        MM: String(date.getMonth() + 1).padStart(2, '0'),
        M: date.getMonth() + 1,
        yyyy: date.getFullYear(),
        yy: String(date.getFullYear()).slice(-2)
    };
    // Matches longer tokens first to avoid partial replacements
    return pattern.replace(/dd|d|MM|M|yyyy|yy/g, (matched) => map[matched]);
}

module.exports = {
    formatDateWithPattern: formatDateWithPattern
};
